import React, { useState, forwardRef } from "react";
import "../packingList/packing.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveSuccessModel from "../../components/common/SaveSuccessModel";

const Option = (props) => {
  return (
    <div>
      <components.Option {...props}>
        <input
          type="checkbox"
          checked={props.isSelected}
          onChange={() => null}
        />{" "}
        <label>{props.label}</label>
      </components.Option>
    </div>
  );
};

const colourOptions = [
  { value: "ocean1", label: "Ocean" },
  { value: "blue", label: "Blue" },
  { value: "purple", label: "Purple" },
  { value: "red", label: "Red" },
  { value: "orange", label: "Orange" },
  { value: "yellow", label: "Yellow" },
  { value: "green", label: "Green" },
  { value: "forest", label: "Forest" },
  { value: "slate", label: "Slate" },
  { value: "silver", label: "Silver" },
];
// datepicker start
const ExampleCustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
  <input
    value={value}
    className="example-custom-input form-control"
    onClick={onClick}
    onChange={onChange}
    ref={ref}
  ></input>
));
// datepicker end

const AddNewPacking = () => {
  const [startDate, setStartDate] = useState(new Date());

  const [distributertag, setDistributerTag] = useState([]);
  const handleChange = (selected) => {
    setDistributerTag(selected);
  };
  return (
    <div className="container-fluid add-new-packing-sec">
      <section className="packing-add-sec mt-3">
        <div className="row">
          <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        Customer Name <span className="mandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Customer Name"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Invoice Number</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Invoice Number"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Invoice Date</label>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        customInput={<ExampleCustomInput />}
                        dayClassName={() => "example-datepicker-day-class"}
                        popperClassName="example-datepicker-class"
                        todayButton="TODAY"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        Consignee <span className="mandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Consignee"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        Buyer's Consignee <span className="mandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Buyer's Consignee"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Origin</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Origin"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Destination</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Destination"
                      ></input>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Details of Pre-Carriage/Carrier Details</label>
                      <textarea
                        className="form-control"
                        placeholder="Enter Details of Pre-Carriage/Carrier Details"
                        rows="5"
                      ></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card mt-3">
              <div className="card-body">
                <div className="row">
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        From Discharge <span className="mandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter From Discharge"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>
                        To Destination <span className="mandatory">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter To Destination"
                      ></input>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                    <div>
                      <label>Condition of Packing</label>
                      <ReactSelect
                        className="basic-multi-select"
                        options={colourOptions}
                        isMulti
                        closeMenuOnSelect={false}
                        hideSelectedOptions={false}
                        components={{
                          Option,
                        }}
                        onChange={handleChange}
                        allowSelectAll={true}
                        value={distributertag}
                        placeholder="Choose Contact Person"
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            neutral80: "#000000",
                          },
                        })}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                    <div className="row">
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>
                            Units of Measurements{" "}
                            <span className="mandatory">*</span>
                          </label>
                          <ReactSelect
                            className="basic-multi-select"
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                      <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>
                            Total Unit Packed{" "}
                            <span className="mandatory">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Total Unit Packed"
                          ></input>
                        </div>
                      </div>
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>
                            Type of Packing- Inside/Outside of The Product{" "}
                            <span className="mandatory">*</span>
                          </label>
                          <ReactSelect
                            className="basic-multi-select"
                            options={colourOptions}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            components={{
                              Option,
                            }}
                            onChange={handleChange}
                            allowSelectAll={true}
                            value={distributertag}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                neutral80: "#000000",
                              },
                            })}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 mb-3">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                        <div>
                          <label>Unit Conversion Details</label>
                          <textarea
                            className="form-control"
                            placeholder="Enter Unit Conversion Details"
                            rows="5"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                <div className="float-right">
                  <button
                    type="button"
                    className="btn add-to-crate-disbaled-btn"
                  >
                    <i class="fas fa-plus mr-2"></i> Add to Crate
                  </button>
                  {/* <button type='button' className='btn add-to-crate-active-btn'><i class="fas fa-plus mr-2"></i> Add to Crate</button> */}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                <div className="card">
                  <div className="card-header">
                    <h6>Product List & Quantity</h6>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                        {/* table start */}
                        <table className="table table-striped table-borderless">
                          <thead>
                            <tr>
                              <th scope="col">
                                <div className="custom-control custom-checkbox custom-checkbox-blue">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input custom-control-input-blue"
                                    id="customCheck1"
                                  />
                                  <label
                                    className="custom-control-label pt-1"
                                    for="customCheck1"
                                  ></label>
                                </div>
                              </th>
                              <th scope="col">Sl.No</th>
                              <th scope="col">Product Name</th>
                              <th scope="col">Model</th>
                              <th scope="col">Kind Of Packing</th>
                              <th scope="col">Description of Goods</th>
                              <th scope="col">Quantity</th>
                              <th scope="col">Net Wgt(Kg)</th>
                              <th scope="col">Gross Wgt(Kg)</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>
                                <div className="custom-control custom-checkbox custom-checkbox-blue">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input custom-control-input-blue"
                                    id="customCheck2"
                                  />
                                  <label
                                    className="custom-control-label pt-1"
                                    for="customCheck2"
                                  ></label>
                                </div>
                              </td>
                              <td>01</td>
                              <td>Fire Damper</td>
                              <td>Model-119</td>
                              <td>Lorem Ipsum</td>
                              <td>In publishing and graphic... More</td>
                              <td>11</td>
                              <td>115</td>
                              <td>120</td>
                            </tr>
                            <tr>
                              <td>
                                <div className="custom-control custom-checkbox custom-checkbox-blue">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input custom-control-input-blue"
                                    id="customCheck2"
                                  />
                                  <label
                                    className="custom-control-label pt-1"
                                    for="customCheck2"
                                  ></label>
                                </div>
                              </td>
                              <td>01</td>
                              <td>Fire Damper</td>
                              <td>Model-119</td>
                              <td>Lorem Ipsum</td>
                              <td>In publishing and graphic... More</td>
                              <td>11</td>
                              <td>115</td>
                              <td>120</td>
                            </tr>
                            <tr>
                              <td>
                                <div className="custom-control custom-checkbox custom-checkbox-blue">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input custom-control-input-blue"
                                    id="customCheck2"
                                  />
                                  <label
                                    className="custom-control-label pt-1"
                                    for="customCheck2"
                                  ></label>
                                </div>
                              </td>
                              <td>01</td>
                              <td>Fire Damper</td>
                              <td>Model-119</td>
                              <td>Lorem Ipsum</td>
                              <td>In publishing and graphic... More</td>
                              <td>11</td>
                              <td>115</td>
                              <td>120</td>
                            </tr>
                          </tbody>
                        </table>
                        {/* table end */}
                      </div>
                    </div>

                    {/* pagination-sec start */}
                    <section className="pagination-sec">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="pagination-d-flex">
                            <div className="d-flex justify-content-end align-items-baseline">
                              <p className="mr-2">Show</p>
                              <select className="form-control">
                                <option selected value="10">
                                  1
                                </option>
                                <option value="2">2</option>
                              </select>
                            </div>
                            <nav
                              aria-label="Page navigation example"
                              className="ml-4"
                            >
                              <ul className="pagination">
                                <li className="page-item">
                                  <a
                                    className="page-link"
                                    href="#"
                                    aria-label="Previous"
                                  >
                                    <span aria-hidden="true">&laquo;</span>
                                    <span className="sr-only">Previous</span>
                                  </a>
                                </li>
                                <li className="page-item">
                                  <a className="page-link active" href="#">
                                    1
                                  </a>
                                </li>
                                <li className="page-item">
                                  <a className="page-link" href="#">
                                    2
                                  </a>
                                </li>
                                <li className="page-item">
                                  <a className="page-link" href="#">
                                    3
                                  </a>
                                </li>
                                <li className="page-item">
                                  <a
                                    className="page-link"
                                    href="#"
                                    aria-label="Next"
                                  >
                                    <span aria-hidden="true">&raquo;</span>
                                    <span className="sr-only">Next</span>
                                  </a>
                                </li>
                              </ul>
                            </nav>
                          </div>
                        </div>
                      </div>
                    </section>
                    {/* pagination-sec end */}
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-3">
                <div className="save-btns">
                  <button type="button" className="btn cancel-btn mr-3">
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn save-btn"
                    data-toggle="modal"
                    data-target="#saveSuccessModal"
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- saveSuccessModal start--> */}
      <SaveSuccessModel />
    </div>
  );
};

export default AddNewPacking;
